import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import 'firebase/firestore'

const firebaseConfig = {
  apiKey: "AIzaSyBbELoOFBWG68FMqy4Vvwmr-85NNal2t5w",
  authDomain: "inmo-grand.firebaseapp.com",
  projectId: "inmo-grand",
  storageBucket: "inmo-grand.appspot.com",
  messagingSenderId: "634518833819",
  appId: "1:634518833819:web:3b9ee2ae445cd7be8a943e"
};

const app = initializeApp(firebaseConfig);
const db = getFirestore(app);

export default db;